module.exports = __webpack_public_path__ + "static/Homepage-Hero2-b3ccfdb63dc7a87d2730583a5c0955be.jpg";